import React, {Fragment} from 'react';
import cx from 'classnames';
import {Step} from './Step';
import styles from './styles.module.scss';

export type StepType = {
    id: string;
    title: string;
    semiFilled?: boolean;
    isFinished?: boolean;
};

export type Steps = {
    [key: number]: StepType;
};

export type StepperProps = {
    activeStep: string;
    steps: Steps;
    componentClasses?: string;
    onClick: (id: string) => void;
};

export const Stepper = (props: StepperProps) => {
    const {steps, componentClasses, onClick, activeStep} = props;
    const stepsKeys = Object.keys(steps);

    return (
        <div className={cx(styles.component, componentClasses)}>
            {stepsKeys.map((stepID, index) => {
                const isActive = stepID === activeStep;
                const prevStep = steps[index - 1];
                const isConnectorSucceed = prevStep?.isFinished;

                const connectorClasses = cx(styles.connector, {
                    [styles.succeed]: isConnectorSucceed,
                    [styles.succeedToActive]: isActive && prevStep?.isFinished
                });

                const step = steps[stepID];

                return (
                    <Fragment key={stepID}>
                        {index < stepsKeys.length ? <div className={connectorClasses} /> : null}
                        <Step {...step} index={index} isActive={isActive} onClick={onClick} />
                    </Fragment>
                );
            })}
        </div>
    );
};
